import "./modal.js";

/**
 * @module page-builder
 */
(function () {
  "use strict";

  var WysiwygDialog = function WysiwygDialog() {
    var _super = new Sparkle.PageBuilder.Modal.Deprecated();
    var self = {};

    _.extend(self, _super, {
      template: "wysiwyg-dialog",
      initialize: function (tool, callback) {
        _super.initialize.apply(this, []);
        jQuery(this.dialog).addClass("wysiwyg-modal");
        var spacingMarker = tool.element.querySelector("[data-wysiwyg-spacing]");

        // The forked tool has no attribute config, so the expanded editor takes the marker of the field it expands.
        if (spacingMarker) {
          this.content.dataset.wysiwygSpacing = spacingMarker.dataset.wysiwygSpacing;
        }

        this.forkedTool = tool.fork(this.content);
        // `fork()` already subscribed the tool to `Event`, so a failed `load()` still needs `remove()`.
        try {
          this.forkedTool.load();
        } catch (error) {
          try {
            this.remove();
          } catch (cleanupError) {
            console.error("Wysiwyg dialog cleanup failed after a load error", cleanupError);
          }
          throw error;
        }
        jQuery(this.content).find(".modal-view").remove();
        this.addPrimaryButton(
          "Done",
          function () {
            try {
              if (this.callback) {
                this.callback(this.forkedTool);
              }
            } finally {
              this.remove();
            }
          }.bind(this),
        );

        this.setCallback(callback);
        this.show();
      },

      setCallback: function (callback) {
        this.callback = callback;
      },

      remove: function () {
        var cleanupError;
        var forkedTool = this.forkedTool;
        this.forkedTool = null;

        if (forkedTool) {
          try {
            forkedTool.unbind();
          } catch (error) {
            cleanupError = error;
          }

          try {
            forkedTool.unload();
          } catch (error) {
            cleanupError = cleanupError || error;
          }
        }

        _super.remove.apply(this, arguments);

        if (cleanupError) {
          throw cleanupError;
        }
      },
    });

    self.initialize.apply(self, arguments);
    return self;
  };

  Sparkle.PageBuilder.WysiwygDialog = WysiwygDialog;
})();
